module.exports = __webpack_public_path__ + "img/title1.3ac5a3b9.png";